<template>
  <div class="box">
    <img style="height: 24px;" :src="imageUrl" class="avatar" @click.stop="openImageViewer">
    <el-image-viewer v-if="imgVisible" :on-close="closeImageViewer" :url-list="[imageUrl]" />
  </div>
</template>

<script>
import Vue from 'vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default Vue.extend({
  components: { ElImageViewer },
  data() {
    return {
      imgVisible: false
    }
  },
  computed: {
    imageUrl() {
      return this.params.value
    }
  },
  methods: {
    openImageViewer() {
      this.imgVisible = true
    },
    closeImageViewer() {
      this.imgVisible = false
    }
  }
})
</script>

<style>
.box {
  text-align: center;
}
</style>
